import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

export const ClubMemberProcessFeeListApi = (ID) =>
    API.get(`${URL.CLUB_MEMBER_PROCESSING_FEES}/${ID}`)
export const ClubSanctionProcessFeeListApi = (ID) =>
    API.get(`${URL.CLUB_SANCTION_PROCESSING_FEES}/${ID}`)
export const AdminMemberProcessFeeListApi = () => API.get(`${URL.ADMIN_MEMBER_PROCESSING_FEES}`)
export const AdminSanctionProcessFeeListApi = () => API.get(`${URL.SANCTION_PROCESSING_FEES_LIST_URL}`)
